var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNexus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 10C0 4.47715 4.47715 0 10 0C15.5228 0 20 4.47715 20 10C20 15.5228 15.5228 20 10 20C4.47715 20 0 15.5228 0 10Z",
    fill: "black"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9896_14460)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.2601 9.49393L9.88383 9.12201L9.85547 9.09375",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.0047 10.0541L10.9194 10.9675H11.6832V8.40068L11.3667 8.71607L11.102 8.97984V10.327L10.4263 9.65321L9.69841 8.92784L8.84688 8.07812H7.96094V10.6405C8.12466 10.4781 8.29406 10.3089 8.46346 10.1404L8.54438 10.0598V8.59888L9.49498 9.5462L9.84323 9.88533",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.48121 9.85521L9.47667 9.85069L9.27967 9.65851L9.2774 9.65625L8.5446 10.3858C8.45347 10.477 8.36235 10.5678 8.27235 10.6571L8.18312 10.746L8.14228 10.7867L8.0814 10.8474L8.04132 10.8873L7.96191 10.9664H7.96683H8.5446H8.74501H8.74917C8.75239 10.966 8.75556 10.9653 8.75862 10.9642L8.76353 10.9619L8.76694 10.96C8.76907 10.9587 8.77099 10.957 8.77261 10.9551C8.86222 10.8685 8.95108 10.7818 9.03956 10.694C9.09124 10.6423 9.14292 10.5905 9.19459 10.5388L9.27022 10.4611L9.34584 10.3831L9.36361 10.3658L9.44415 10.2855L9.48802 10.2414L9.5107 10.2192L9.55532 10.1747L9.61998 10.1107L9.65779 10.073L9.67594 10.0549L9.6075 9.9886L9.48121 9.85521Z",
    fill: "#3EF2D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4225 9.32774C10.5796 9.17124 10.7366 9.01486 10.8937 8.85861L11.102 8.65136L11.3667 8.38759L11.5236 8.23121L11.6809 8.07446L11.6832 8.0722L11.6677 8.07031H11.6635H11.6598H11.6503H10.8975H10.8929L10.885 8.07295H10.8808C10.8757 8.07533 10.871 8.07851 10.8668 8.08237L10.8377 8.10988L10.809 8.13814L10.7663 8.18072L10.7523 8.19466L10.6925 8.25458C10.6324 8.31411 10.5727 8.37403 10.5129 8.43356L10.1178 8.8262L10.0932 8.85107C10.0682 8.87594 10.0437 8.90157 10.0176 8.92644L10.0682 8.97655L10.4225 9.32774Z",
    fill: "#3EF2D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5947 13.2815C14.7265 12.1536 13.955 9.55598 11.8715 7.47962C9.78789 5.40326 7.18127 4.63441 6.04941 5.76236C4.91755 6.89031 5.68907 9.48791 7.77263 11.5643C9.8562 13.6406 12.4628 14.4095 13.5947 13.2815Z",
    stroke: "#3EF2D0",
    strokeWidth: 0.655907,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8715 11.5594C13.955 9.48308 14.7265 6.88547 13.5947 5.75752C12.4628 4.62958 9.8562 5.39842 7.77263 7.47478C5.68907 9.55115 4.91755 12.1488 6.04941 13.2767C7.18127 14.4047 9.78789 13.6358 11.8715 11.5594Z",
    stroke: "white",
    strokeWidth: 0.655907,
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9896_14460"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12.2857,
    height: 12,
    fill: "white",
    transform: "translate(4 4)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNexus);
export default __webpack_public_path__ + "static/media/nexus.bd16a01979c899abccc958a99e739766.svg";
export { ForwardRef as ReactComponent };